import React from "react";
import styled, { css } from "styled-components";
import { rem, transparentize } from "polished";
import Button from "../../../Button";

const ListItem = ({
  data,
  onHandleSet,
  onModalClose,
  setSingleData = false,
  selectedKey = "",
  onSetDetailModal,
  setSelectedItem,
}) => {
  if (!data) return void 0;

  const handleSetData = (data) => {
    if (!setSingleData && selectedKey === "") onHandleSet(data);
    else {
      let items = {};
      items[selectedKey] = data;
      onHandleSet(items);
    }
    onModalClose();
  };

  return (
    <ListItemLayout style={{ borderTop: "30px solid transparent" }}>
      {data.map((option, i) => {
        const { label, desc, image, price, unit } = option;
        return (
          <div className="item" key={i}>
            <div className="item-title">
              <h6 dangerouslySetInnerHTML={{ __html: label || desc }} />
              <span>{[price, unit].join(" ")}</span>
            </div>
            <div className="item-content">
              <div
                className="item-image"
                onClick={() => {
                  setSelectedItem?.(option);
                  onSetDetailModal?.(true);
                }}
              >
                <img src={image} alt={label || desc} />
              </div>
              <div className="button-wrapper">
                <Button onClick={() => handleSetData(option)}>VÄLJ</Button>
              </div>
            </div>
          </div>
        );
      })}
    </ListItemLayout>
  );
};
export default ListItem;

const ListItemLayout = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
    row-gap: 30px;

    .item {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0 15px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;

      @media (max-width: 991px) {
        flex: 0 0 33.333%;
        max-width: 33.333%;
      }

      @media (max-width: 767px) {
        flex: 0 0 50%;
        max-width: 50%;
      }

      @media (max-width: 480px) {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .item-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: ${rem(20)};

        h6 {
          font-size: ${rem(14)};
          margin: 0;
          text-transform: capitalize;
        }

        span {
          font-size: ${rem(12)};
          color: ${theme.colors.primary};
          flex-grow: 1;
          white-space: nowrap;
          text-align: right;
          margin-left: ${rem(10)};
        }
      }

      .item-content {
        margin-top: auto;

        .item-image {
          text-align: center;
          position: relative;
        }
        .button-wrapper {
          margin-top: ${rem(20)};
          button {
            width: 100%;
            background-color: ${transparentize(0.91, theme.colors.black)};
            border: none;
            padding: 15px 0;
            cursor: pointer;
            position: relative;
            color: #000;
            overflow: hidden;
            transition: 0.3s ease all;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: ${theme.colors.primary};
              top: 0;
              left: 0;
              pointer-events: none;
              z-index: -1;
              transform: translateX(calc(100% - 22px)) skewX(-45deg);
              transition: 0.3s ease all;
            }

            &:hover {
              color: ${theme.colors.white};
              &::after {
                transform: translateX(22px) skewX(-45deg);
              }
            }
          }
        }
      }
    }
  `}
`;
